import Vue from "vue";
import { Commit, Getter } from "vuex";
import ApiService from "../lib/api";

interface Country {
  name: string;
  code: string;
}

interface CountriesState {
  countries: Record<string, string>;
  guess: Country | null;
}

const state: CountriesState = {
  countries: {},
  guess:  null,
};

const mutations = {
  setOptions(state: CountriesState, payload: Country[]): void {

    Vue.set(state, 'countries', payload);
  },
  setGuess(state: CountriesState, payload: Country): void {
    Vue.set(state, 'guess', payload);
  }
};

const actions = {
  fetchOptions({commit, getters}: {commit: Commit, getters: any}): Promise<any> {
    return new Promise((resolve, reject) => {
      if (Object.keys(getters.options).length > 0) {
        resolve();
        return;
      }

      ApiService.get('/countries/options').then((resp: ApiResponseArray<Country>) => {
        commit('setOptions', resp.data);

        if (resp.meta.guess) {
          commit('setGuess', resp.meta.guess);
        }

        resolve();
      }).catch(() => {
        reject();
      });
    });
  }
};

const getters = {
  options: (state: CountriesState): Record<string, string> => {
    return state.countries;
  },
  guess: (state: CountriesState): Country | null => {
    return state.guess;
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
